<script>
  import Help from "../components/help.svelte";
  </script>
<svelte:head>
  <title>FAQ | eAdmissions</title>
</svelte:head>
  <Help helpId={"TechFAQ"} showSearchOption={true} back="/help"/>